import * as React from 'react';
import { Modal } from 'antd';
import Form, { FormItem } from '../../../../../components/Form';
import TextArea from 'antd/lib/input/TextArea';

interface IInvoiceNotesSettingsModalProps {
  order: GQL.IOrder;
  onSubmit: (data: any) => void;
  onClose: () => void;
}

interface IInvoiceNotesSettingsModalState {
  data: {
    invoiceNotes: string | null;
  };
}

class InvoiceNotesSettingsModal extends React.Component<IInvoiceNotesSettingsModalProps, IInvoiceNotesSettingsModalState> {

  private form;

  constructor(props: IInvoiceNotesSettingsModalProps) {
    super(props);

    this.state = {
      data: {
        invoiceNotes: props.order.invoiceNotes,
      },
    };

    this.form = React.createRef;

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  public render() {
    return (
      <div>
        <Modal
          title="Invoice notes settings"
          visible={true}
          okText={'Save changes'}
          onOk={this.onSubmit}
          onCancel={this.props.onClose}
          destroyOnClose={true}
          maskClosable={false}
        >
          <Form
            ref={f => this.form = f}
            displayFooter={false}
            onSubmit={this.onSubmit}
            onCancel={this.props.onClose}
          >
            <FormItem label={'Invoice notes'}>
              <TextArea
                name={'invoiceNotes'}
                placeholder="Enter invoice notes"
                value={this.state.data.invoiceNotes || ''}
                rows={5}
                onChange={this.onChange}
              />
            </FormItem>
          </Form>
        </Modal>
      </div>
    );
  }

  private onChange(e: any, val?: string) {
    const { name, value } = e.target;

    const inputValue = (val ? val : value);

    this.setState({
      data: { ...this.state.data, [name]: inputValue }
    });
  }

  private onSubmit() {
    if (this.form) {
      if (this.form.validate()) {
        this.props.onSubmit(this.state.data);
      }
    }
  }
}

export default InvoiceNotesSettingsModal;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/InvoiceNotesSettings/components/Modal.tsx